import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Dive into destination-focused articles on First-Class.com. Get inspired with travel guides, tips, and cultural insights for your next adventure'
          }
        />
        <title>Destination Articles: Explore Destinations in Detail</title>
      </Head>
      <ArticlesList
        subtype="Articles"
        type="Destinations"
        heading="Destination articles"
      />
    </>
  );
}

export default withLayout(Articles, true);
